import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitQuote = (payload) => axios.post(`${API}/quotes`, payload).then((r) => r.data);

const adminHeaders = (passcode) => ({ headers: { "X-Admin-Passcode": passcode } });

export const adminLogin = (passcode) => axios.post(`${API}/admin/login`, { passcode }).then((r) => r.data);
export const fetchQuotes = (passcode, status) =>
  axios.get(`${API}/admin/quotes`, { ...adminHeaders(passcode), params: status ? { status } : {} }).then((r) => r.data);
export const updateQuoteStatus = (passcode, id, status) =>
  axios.patch(`${API}/admin/quotes/${id}/status`, { status }, adminHeaders(passcode)).then((r) => r.data);
export const deleteQuote = (passcode, id) => axios.delete(`${API}/admin/quotes/${id}`, adminHeaders(passcode));

export const fetchGallery = () => axios.get(`${API}/gallery`).then((r) => r.data);
export const uploadGalleryPhoto = (passcode, { file, title, sub }, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  form.append("title", title);
  form.append("sub", sub || "");
  return axios
    .post(`${API}/admin/gallery`, form, {
      ...adminHeaders(passcode),
      onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
    })
    .then((r) => r.data);
};
export const updateGalleryPhoto = (passcode, id, payload) => axios.patch(`${API}/admin/gallery/${id}`, payload, adminHeaders(passcode)).then((r) => r.data);
export const deleteGalleryPhoto = (passcode, id) => axios.delete(`${API}/admin/gallery/${id}`, adminHeaders(passcode));
export const galleryImageUrl = (photo) => `${process.env.REACT_APP_BACKEND_URL}${photo.url}`;
export const fetchHiddenBuiltins = () => axios.get(`${API}/gallery/hidden-builtins`).then((r) => r.data);
export const hideBuiltin = (passcode, id) => axios.post(`${API}/admin/gallery/builtin/${id}/hide`, {}, adminHeaders(passcode)).then((r) => r.data);
export const restoreBuiltin = (passcode, id) => axios.delete(`${API}/admin/gallery/builtin/${id}/hide`, adminHeaders(passcode)).then((r) => r.data);
export const fetchBuiltinOverrides = () => axios.get(`${API}/gallery/builtin-overrides`).then((r) => r.data);
export const updateBuiltin = (passcode, id, payload) => axios.patch(`${API}/admin/gallery/builtin/${id}`, payload, adminHeaders(passcode)).then((r) => r.data);
